import React, { useState } from 'react';
import { X as CloseIcon, Maximize2Icon, Minimize2Icon } from 'lucide-react';
import { mockApps } from '../../utils/mockData';
interface TabInterfaceProps {
  tabs: string[];
  activeTab: string | null;
  onTabChange: (tabId: string) => void;
  onTabClose: (tabId: string) => void;
  onCloseAll: () => void;
}
export const TabInterface = ({
  tabs,
  activeTab,
  onTabChange,
  onTabClose,
  onCloseAll
}: TabInterfaceProps) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [draggingTab, setDraggingTab] = useState<string | null>(null);
  const handleDragStart = (e: React.DragEvent, tabId: string) => {
    setDraggingTab(tabId);
    e.dataTransfer.setData('text/plain', tabId);
  };
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };
  const handleDrop = (e: React.DragEvent, targetTabId: string) => {
    e.preventDefault();
    if (draggingTab && draggingTab !== targetTabId) {
      const newTabs = [...tabs];
      const draggedIdx = newTabs.indexOf(draggingTab);
      const targetIdx = newTabs.indexOf(targetTabId);
      newTabs.splice(draggedIdx, 1);
      newTabs.splice(targetIdx, 0, draggingTab);
    }
    setDraggingTab(null);
  };
  const app = activeTab ? mockApps.find(a => a.id === activeTab) : null;
  return <div className={`${isFullscreen ? 'fixed inset-0 z-50' : ''} bg-white flex flex-col h-full`} data-id="element-313">
      <div className="flex items-center justify-between border-b bg-gray-50" data-id="element-314">
        <div className="flex-1 flex overflow-x-auto" data-id="element-315">
          {tabs.map(tabId => {
          const app = mockApps.find(a => a.id === tabId);
          if (!app) return null;
          return <div key={tabId} draggable onDragStart={e => handleDragStart(e, tabId)} onDragOver={handleDragOver} onDrop={e => handleDrop(e, tabId)} className={`flex items-center px-4 py-2 border-r cursor-pointer min-w-[150px] ${activeTab === tabId ? 'bg-white border-b-2 border-b-indigo-600' : 'bg-gray-50 text-gray-600'}`} onClick={() => onTabChange(tabId)} data-id="element-316">
                <span className="mr-2 truncate" data-id="element-317">{app.title}</span>
                <button className="hover:bg-gray-200 rounded p-0.5" onClick={e => {
              e.stopPropagation();
              onTabClose(tabId);
            }} data-id="element-318">
                  <CloseIcon className="h-4 w-4" data-id="element-319" />
                </button>
              </div>;
        })}
        </div>
        <div className="flex items-center px-2 border-l border-gray-200" data-id="element-320">
          <button className="p-2 hover:bg-gray-200 rounded mr-2 group relative" onClick={() => setIsFullscreen(!isFullscreen)} data-id="element-321">
            {isFullscreen ? <Minimize2Icon className="h-5 w-5" data-id="element-322" /> : <Maximize2Icon className="h-5 w-5" data-id="element-323" />}
            <span className="absolute hidden group-hover:block right-0 top-full mt-1 px-2 py-1 text-xs bg-gray-800 text-white rounded whitespace-nowrap" data-id="element-324">
              {isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
            </span>
          </button>
          <button className="p-2 hover:bg-gray-200 rounded group relative" onClick={onCloseAll} data-id="element-325">
            <CloseIcon className="h-5 w-5" data-id="element-326" />
            <span className="absolute hidden group-hover:block right-0 top-full mt-1 px-2 py-1 text-xs bg-gray-800 text-white rounded whitespace-nowrap" data-id="element-327">
              Close all Apps
            </span>
          </button>
        </div>
      </div>
      {app && <div className="flex-1 overflow-auto p-6" data-id="element-328">
          <div className="max-w-4xl mx-auto" data-id="element-329">
            <h2 className="text-2xl font-bold mb-6" data-id="element-330">{app.title}</h2>
            <div className="bg-white rounded-lg shadow-sm p-6 space-y-6" data-id="element-331">
              {/* Add your app interface components here */}
              <div className="space-y-4" data-id="element-332">
                <h3 className="text-lg font-medium" data-id="element-333">App Interface</h3>
                <p className="text-gray-600" data-id="element-334">
                  This is where your app's main interface would be displayed.
                </p>
              </div>
              <div className="space-y-4" data-id="element-335">
                <h3 className="text-lg font-medium" data-id="element-336">Settings</h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-337">
                  <div className="space-y-2" data-id="element-338">
                    <label className="block text-sm font-medium text-gray-700" data-id="element-339">
                      Model
                    </label>
                    <select className="w-full border rounded-md px-3 py-2" data-id="element-340">
                      <option data-id="element-341">GPT-4</option>
                      <option data-id="element-342">GPT-3.5</option>
                    </select>
                  </div>
                  <div className="space-y-2" data-id="element-343">
                    <label className="block text-sm font-medium text-gray-700" data-id="element-344">
                      Temperature
                    </label>
                    <input type="range" min="0" max="1" step="0.1" className="w-full" data-id="element-345" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};